import { Input } from "@/components/Input";
import SubLayout from "@/components/SubLayout";
import { Form } from "antd-mobile";
import { useEffect } from "react";
import { useLogic } from "./logic";
export function PageUserName() {
  const logic = useLogic();
  useEffect(() => {
    if (logic.userInfo.userName) {
      logic.form.setFieldsValue({
        userName: logic.userInfo.userName,
      });
    }
  }, [logic.userInfo.userName]);

  return (
    <SubLayout
      title={"个人信息"}
      header={{
        extra: <div onClick={logic.saveData}>存储</div>,
      }}
    >
      <Form form={logic.form} className={"common-form"}>
        <Form.Item name="userName" label="用户名">
          <Input placeholder="用户名为4-20位字符" />
        </Form.Item>
      </Form>
    </SubLayout>
  );
}
